import React, { ReactElement, useRef } from "react";
import { AriaModalOverlayProps, useOverlayTrigger } from "react-aria";
import {
  useOverlayTriggerState,
  OverlayTriggerProps,
  OverlayTriggerState,
} from "react-stately";

import { ModalOverlay } from "./ModalOverlay";
export interface ModalTriggerPropsDeprecated
  extends OverlayTriggerProps,
    AriaModalOverlayProps {
  children: (close: () => void) => ReactElement;
  trigger: (state: OverlayTriggerState) => React.ReactElement;
}

export function ModalTrigger(props: ModalTriggerPropsDeprecated) {
  const { children, trigger, ...rest } = props;
  const ref = useRef<HTMLButtonElement>(null);
  const state = useOverlayTriggerState(rest);
  const { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    state,
    ref
  );

  return (
    <>
      {React.cloneElement(trigger(state), triggerProps)}
      {state.isOpen && (
        <ModalOverlay {...rest} state={state}>
          {React.cloneElement(children(state.close), overlayProps)}
        </ModalOverlay>
      )}
    </>
  );
}
